import { getElementQuery } from './Elements'

const CRSF_TOKEN_NAME = 'csrf-token'

export const getCSRFToken = () => getElementQuery(`meta[name=${CRSF_TOKEN_NAME}]`)?.getAttribute('content')
